import { decode } from 'jsonwebtoken';

export const setToken = token => {
  if (token) {
    window.localStorage.setItem('token', JSON.stringify(token));
  }
};

export const setBiData = token => {
  if (token) {
    const { userId, accountId, iss, name, fullName } = decode(token);
    window.localStorage.setItem(
      'bi_data',
      JSON.stringify({
        userId,
        accountId,
        iss,
        name,
        fullName,
      })
    );
  }
};

export const clearLocalStorage = window.localStorage.clear;
